import React from "react";
import BasicsVenuesTabV3 from "./BasicsVenuesTabV3";
import TicketArchitectTabV3 from "./TicketArchitectTabV3";
import { BasicsVenuesTabProps, TicketArchitectTabProps } from "./ComponentPropsV3";

export interface QuickEventStudioV3Props {
  basicsProps: BasicsVenuesTabProps;
  ticketProps: TicketArchitectTabProps;
}

const QuickEventStudioV3: React.FC<QuickEventStudioV3Props> = ({
  basicsProps,
  ticketProps,
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <BasicsVenuesTabV3 {...basicsProps} />
      <TicketArchitectTabV3 {...ticketProps} />
    </div>
  );
};

export default QuickEventStudioV3;
